/** @module csi/table/matrix/ColumnRootMap */
define([
	"dojo/_base/declare",
	"./_RootMap"
], function(declare,_RootMap) {

	/**
	 * This matrix allows you to have an editable matrix in a view of aggregate data, where the data is stored in a
	 * map on the root node of the view. The key to the map is composed from unique ids from the row and column nodes.
	 *
	 * Reference: https://centric8.atlassian.net/wiki/spaces/AAT/pages/1298825877/Table+Matrix+Configuration#ColumnRootMap
	 */

	return declare(_RootMap, {
		/** @property {string} mapKeyColumnId - attribute id of column class that holds unique id for column */
		mapKeyColumnId: "SysID",

		/** @property {string} mapKeyRowId - attribute id of row class that holds unique id for row */
		mapKeyRowId: "SysID",

		/** @property {string} mapKeySeparator - separator used to join row and column unique id values */
		mapKeySeparator: "^",

		/**
		 * @override
		 * Return index based on row and column unique id values
		 */
		_getSpecIndices: function(ctx, spec, nodes) {
			var row = nodes[0];
			var column = ctx.cache.getNode(spec.columnUrl);
			var key = row[this.mapKeyRowId] + this.mapKeySeparator + column[this.mapKeyColumnId];

			// check that separator does not appear in row and column values
			console.assert(key.match(new RegExp(this.mapKeySeparator)).length === 1);
			return [key];
		}
	});
});